export const EXPIRY_SKEW_SECONDS = 30;
export const REFRESH_LEAD_MS = 60_000;

type JwtPayload = { exp: number };

const base64UrlDecode = (segment: string): string => {
  const normalized = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized + '==='.slice((normalized.length + 3) % 4);
  return atob(padded);
};

export const decodeJwt = (token: string | null | undefined): JwtPayload | null => {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const payload = JSON.parse(base64UrlDecode(parts[1]));
    if (typeof payload?.exp !== 'number') return null;
    return { exp: payload.exp };
  } catch {
    return null;
  }
};

export const isTokenExpired = (
  token: string | null | undefined,
  skewSeconds: number = EXPIRY_SKEW_SECONDS
): boolean => {
  const payload = decodeJwt(token);
  if (!payload) return true;
  return payload.exp * 1000 - Date.now() <= skewSeconds * 1000;
};

export const msUntilExpiry = (token: string | null | undefined): number | null => {
  const payload = decodeJwt(token);
  if (!payload) return null;
  return payload.exp * 1000 - Date.now();
};
